var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l1"},[_c('div',{ref:"lchart",staticClass:"lchart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }